// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m9Dv","selected":"styles_selected__KY3H3"};